import { useSearchParams } from "react-router-dom";
import { useEffect, useRef } from "react";
import { useAuth } from "../AuthProvider";
import useGetShareAuth from "@/api/routes/no-auth-share/get-share-auth";
import { setCurrentAppInstanceId } from "../token-utils";

const generateUniqueId = () =>
  `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;

export const SharingAuthProvider = ({ children }) => {
  const [searchParams] = useSearchParams();
  const { setLoginAuth, abstractRequestId, checkUserAuthSession } = useAuth();
  const token = searchParams.get("token");
  const { data, isSuccess } = useGetShareAuth(true, token);
  const appInstanceId = useRef(generateUniqueId());

  useEffect(() => {
    setCurrentAppInstanceId(appInstanceId.current);
  }, []);

  useEffect(() => {
    (async () => {
      if (data.jwt && isSuccess && appInstanceId.current) {
        await setLoginAuth({
          jwt: data.jwt,
          appInstanceId: appInstanceId.current,
        });
      }
    })();
  }, [setLoginAuth, data.jwt, isSuccess]);

  useEffect(() => {
    if (data.jwt) {
      checkUserAuthSession(true, appInstanceId.current);
    }
  }, [data.jwt, checkUserAuthSession]);

  if (data.jwt && abstractRequestId) {
    return children({ abstractRequestId });
  } else {
    return null;
  }
};

export default SharingAuthProvider;
